import {
  ProfileAction,
  CHANGING_PASSWORD,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_FAIL,
  CHANGE_PASSWORD_SUCCESS,
  EDITING_PROFILE_FORM,
  END_ACTION,
  VALIDATE_FORM_ERROR,
} from "./actionTypes";

interface ProfileState {
  working: boolean;
  changing_password: boolean;
  profile_form_data: {
    [key: string]: any;
  };
  modal_data:
    | {
        title: string;
        submitText: string;
        submitStyle: string;
      }
    | {};
  success: null | boolean;
  error?: null | string[];
}

const INITIAL_PROFILE_FORM_DATA = {};

const initialState: ProfileState = {
  working: false, // indicates that remote fetching is in progress
  changing_password: false, // shows the modal dialog
  profile_form_data: INITIAL_PROFILE_FORM_DATA,
  modal_data: {},
  success: null,
};

// OTHER CONSTANTS
export const CHANGE_PASSWORD_MODAL_DATA = {
  title: "Change User Password",
  submitText: "Update Password",
  submitStyle: "success",
};

export function reducer(
  state = initialState,
  action: ProfileAction
): ProfileState {
  switch (action.type) {
    case CHANGING_PASSWORD:
      return {
        ...state,
        changing_password: true,
        modal_data: CHANGE_PASSWORD_MODAL_DATA,
      };
    case CHANGE_PASSWORD:
      return { ...state, working: true };
    case CHANGE_PASSWORD_FAIL:
      return {
        ...state,
        working: false,
        error: [`${action.error.message}`],
      };
    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        error: null,
        working: false,
        changing_password: false,
        profile_form_data: INITIAL_PROFILE_FORM_DATA,
        success: true,
      };
    case EDITING_PROFILE_FORM:
      return {
        ...state,
        profile_form_data: {
          ...state.profile_form_data,
          [action.input_id]: action.input_value,
        },
      };
    case END_ACTION:
      return {
        ...state,
        // TODO: should working be here??? if so, add to users.js also
        working: false,
        changing_password: false,
        profile_form_data: INITIAL_PROFILE_FORM_DATA,
        error: null,
      };
    case VALIDATE_FORM_ERROR:
      return { ...state, error: action.error };

    default:
      return state;
  }
}
